import React from 'react';
import { useSearchParams } from 'react-router-dom';
import BulletinCommande from '../components/BulletinCommande';

const Checkout = () => {
  const [searchParams] = useSearchParams();
  const productId = searchParams.get('product');
  const paiement = searchParams.get('paiement');
  const duree = searchParams.get('duree');

  return (
    <BulletinCommande
      apiEndpoint="/api/commande"
      preselectedProduct={productId}
      preselectedPaiement={paiement}
      preselectedDuree={duree}
      logoSrc="https://customer-assets.emergentagent.com/job_site-refresh-17/artifacts/c90xxily_ECOCLIMA_logo2_HD%20copie.png"
      onSuccess={(ref, data) => {
        // Commande enregistree
      }}
    />
  );
};

export default Checkout;
